import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  OnDestroy,
  Input,
  OnChanges,
  SimpleChanges,
  ViewChild,
  QueryList,
  ViewChildren,
  ChangeDetectorRef,
} from "@angular/core";
import { NbDialogService } from "@nebular/theme";
import { Observable, map, of } from "rxjs";
import { DataService } from "../../../../@core/utils/data.service";
import { EventBusService } from "../../../../@core/utils/eventbus.service";
import { DialogAttributeComponent } from "../dialog-attribute/dialog-attribute.component";
import { isJSON, ValidInput } from "../../../../@core/utils/helpers";
import { NgSelectComponent } from "@ng-select/ng-select";
import { FormControl } from "@angular/forms";

@Component({
  selector: "input-static-conditions",
  templateUrl: "./input-static-conditions.component.html",
  styleUrls: ["./input-static-conditions.component.scss"],
})
export class InputStaticConditions implements OnInit, OnDestroy, OnChanges {
  @Output() propertyEmit = new EventEmitter<string>();
  @Input() propertyInput: string;
  @Input() title: string;
  @Input() propertyName: string = "";
  @Input() propertyValue: string;
  @Input() selectAttribute: boolean;
  @Input() disabled: boolean;
  @Input() onlyValue: boolean = false;
  @Input() disabledAddNew: boolean = false;
  @Input() maxHeight: boolean = true;
  @Input() filteredOptions$: Observable<any[]> = of(
    this.dataService.ivrAttribute
  );

  @ViewChildren(NgSelectComponent)
  selectComponents: QueryList<NgSelectComponent>;
  selectValueComponents: QueryList<NgSelectComponent>;

  properties: Property[] = [];
  ivrFunction: any = this.dataService.ivrFunction;
  attributes: any = this.dataService.ivrAttribute;
  oldPropertyInput: any[] = [];
  mentionConfig = {
    items: this.attributes,
    triggerChar: "{",
    labelKey: "value",
    disableSort: true,
    mentionSelect: (item) => {
      return "{" + item.value + "}";
    },
  };
  listCondition = [
    "Equal",
    "Not equal",
    "Is less than",
    "Is less than or equal",
    "Is greater than",
    "Is greater than or equal",
    "Starts with",
    "Ends with",
    "Contains",
    "Empty",
    "Exist",
  ];
  listValue = ["true", "false"];
  filteredConditions$: Observable<any[]> = of(this.listCondition);
  filteredValue$: Observable<any[]> = of(this.listValue);
  constructor(
    public dataService: DataService,
    private eventBusService: EventBusService,
    private dialogService: NbDialogService
  ) {
    this.eventBusService.on("clickConfirmTestFunction", (isTrue: boolean) => {
      if (isTrue) {
        this.propertyEmit.emit(this.propertyToString());
      }
    });
  }

  addTagFn = (term) => {
    let newStr = term?.trim().replace(/[{}]/g, "");
    let validateNewStr = new FormControl(newStr, ValidInput.variable);
    if (validateNewStr.valid) {
      this.dataService.ivrAttribute.push({
        default: 0,
        value: newStr,
      });
      this.dataService.ivrAttributeArray.push(newStr);
    }
    return newStr;
  };
  onChangeContent(event, i) {
    const textArea = document.getElementById("textarea-value-" + i);
    if (textArea) {
      if (event?.target?.value?.trim()) {
        textArea.style.height = `${textArea.scrollHeight}px`;
      } else {
        textArea.style.height = "32.4px";
      }
    }
  }
  ngOnChanges(changes: SimpleChanges): void {
    this.stringToProperty();
  }

  ngOnDestroy(): void {
    this.propertyEmit.emit(this.propertyToString());
  }
  getValue(): void {
    this.propertyEmit.emit(this.propertyToString());
  }
  getData() {
    return JSON.stringify(this.properties);
  }

  ngOnInit() {
    if (!this.disabledAddNew) {
      this.filteredOptions$ = this.filteredOptions$.pipe(
        map((options) => [{ default: "VARIABLE", value: "" }, ...options])
      );
    }
    if (this.propertyInput) {
      let data = [];
      try {
        data = JSON.parse(this.propertyInput);
      } catch (error) {}
      let customVariable = [];
      data?.forEach((element) => {
        let dataExist = this.dataService.ivrAttribute.find(
          (x) => x.value == element.name
        );
        if (
          !dataExist &&
          element?.name?.trim() != "" &&
          element?.name != null
        ) {
          if (!customVariable.includes(element.name?.trim())) {
            this.filteredOptions$ = this.filteredOptions$.pipe(
              map((options) => [
                ...options,
                { default: element.name, value: element.name },
              ])
            );
            customVariable.push(element.name?.trim());
          }
        }
      });
    }
    this.stringToProperty();
  }

  addProperty() {
    let property = new Property();
    property.name = null;
    if (this.onlyValue == true) {
      property.name = this.propertyName;
    }
    property.value = null;
    this.properties.push(property);
  }

  propertyToString() {
    for (const prop of this.properties) {
      prop.name = prop.name?.trim();
      prop.condition = prop.condition?.trim();
      prop.value = prop.value?.trim();
    }
    this.properties = this.properties.filter((prop) => {
      if (prop.name && prop.condition && prop.value) {
        return true;
      }
    });
    return JSON.stringify(this.properties);
  }
  selectCondition(value, index) {
    if (value == "Empty" || value == "Exist") {
      if (
        this.properties[index].value?.trim() != "true" &&
        this.properties[index].value?.trim() != "false"
      ) {
        this.properties[index].value = null;
      }
    }
  }
  selectVariable(value, index) {
    if (value?.default == "VARIABLE") {
      this.dialogService
        .open(DialogAttributeComponent, { autoFocus: false })
        .onClose.subscribe((rs) => {
          if (rs) {
            this.filteredOptions$ = this.filteredOptions$.pipe(
              map((options) => [...options])
            );
            this.selectComponents.toArray()[index].writeValue(rs);
            this.properties[index].name = rs;
            this.oldPropertyInput[index] = rs;
          } else {
            this.selectComponents
              .toArray()
              [index].writeValue(this.oldPropertyInput[index]);
            this.properties[index].name = this.oldPropertyInput[index];
          }
        });
    } else {
      if (value && typeof value == "string") {
        this.oldPropertyInput[index] = value?.trim();
        this.properties[index].name = value?.trim(); //custom variable
      }
      if (value && typeof value == "object") {
        this.oldPropertyInput[index] = value?.value?.trim();
        this.properties[index].name = value?.value?.trim(); //custom variable
      }
    }
  }

  dropValue($event, index) {
    this.properties[index].value +=
      "{" + $event.dataTransfer.getData("text").trim() + "}";
    $event.preventDefault();
  }

  removeProperty(index) {
    this.properties.splice(index, 1);
    this.oldPropertyInput.splice(index, 1);
  }

  stringToProperty() {
    this.properties = [];
    if (this.propertyInput != "") {
      if (isJSON(this.propertyInput)) {
        this.properties = JSON.parse(this.propertyInput);
      } else {
      }
    }
  }

  customSearchFn(term: string, item: any): boolean {
    return item.value.includes(term);
  }
}

export class Property {
  name: string;
  condition: string;
  value: string;
}
